<div 
    class="{{unfilled ? 'unfilled' : 'filled'}}" 
    [matTooltip]="(unfilled ? 'SPECIFICATION.BLANK_FIELDS' : 'SPECIFICATION.FILLED_FIELDS') | translate">
</div>
